import { useState, useEffect } from 'react';
import { signInAnonymously, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        // User is signed in
        setUser(currentUser);
        setLoading(false);
      } else {
        // No user signed in, sign in anonymously
        try {
          const result = await signInAnonymously(auth);
          setUser(result.user);
          console.log('Anonymous user signed in:', result.user.uid);
        } catch (err) {
          console.error('Error signing in anonymously:', err);
          setError(err.message);
        } finally {
          setLoading(false);
        }
      }
    });

    // Cleanup subscription
    return () => unsubscribe();
  }, []);

  return { user, loading, error };
};
